<h1 class="logoPrincipal">
  <a alt="Siriema - Autorização Ambiental para Pesca Amadora ou Desportiva" title="Siriema - Autorização Ambiental para Pesca Amadora ou Desportiva">
    <img src="assets/img/siriema.png" alt="Siriema - Autorização Ambiental para Pesca Amadora ou Desportiva">
  </a>
</h1>
<div style="text-align: center; color: #ffffff; font-weight: bold; margin-bottom: 20px">
  <i class="fa fa-phone"></i> Contato: (67) 3318-3600
</div>

<div class="menu-lateral"><!--class="link-row" style="cursor: pointer"-->
  <ul>
    <li><a routerLink="/usuario/detalhe/{{idUsuario}}"><i class="icon-avatar"></i>Meu Perfil</a></li>
    <li><a class="link-row" style="cursor: pointer; color: #FFFFFF;"><i class="icon-id-hor-card"></i>Autorizações de Pesca</a>
  <ul>
    <li><a routerLink="/autorizacao/lista"><i class="icon-id-humb-card"></i>Minhas Autorizações</a></li>
    <li><a routerLink="/autorizacao/nova"><i class="icon-id-plus-card"></i>Nova Autorização</a></li>
  </ul>
    </li>
    <li><a href="#" (click)="logout()"><i class="icon-logout"></i>Sair</a></li>
  </ul>
</div>